export default __webpack_public_path__ + "static/media/pencil-hot-spring.d232e3b3.png";